import { RESPONSE_HEADER } from "../utils/enums";

export const konditionenKey = "edelmetallProduktKonditionen";
export const konditionenListe = "listeEdelmetallProduktKonditionen";
export const stufenKonditionen = "listeStufenKonditionen";
export const konditionenAbsolut = "konditionAbsolut";
export const defaultKeys = [
  "defaultEmBpBuyKondition",
  "defaultEmMaBuyKondition",
  "defaultEmWlBuyKondition",
];
export const defaultBetrag = [
  "defaultEmBpBuyBetrag",
  "defaultEmMaBuyBetrag",
  "defaultEmWlBuyBetrag",
];
export const listKeys = {
  editierbar: ["emBpBuyEditierbarKz", "emMaBuyEditierbarKz", "emWlBuyEditierbarKz"],
  konditionen: ["emBpBuyKondition", "emMaBuyKondition", "emWlBuyKondition"],
  changed: ["emBpBuyChanged", "emMaBuyChanged", "emWlBuyChanged" ],
  preis: ["emBpBuyPreis", "emMaBuyPreis", "emWlBuyPreis"],
  mwst: "mwst",
  headers: ["Beratershop", "Mitarbeiter Konditionen", "Verkauf Kundenshop"],
  preisHeaders: ["BayernLB Retail Preise", "", ""],
  isMaKond: [false, true, false],
};

export const testData = {
  "header": { "status": RESPONSE_HEADER.STATUS.SUCCESSFUL, "version": "2.0.0.0", "build": "b1539", "sessionId": "202207232257559715309" },
  "hashCode": "202110051140",
  "defaultEmBpBuyKondition": 1,
  "defaultEmWlBuyKondition": 1,
  "defaultEmBpBuyBetrag": 3,
  "defaultEmWlBuyBetrag": 5,
  "edelmetallProduktKonditionen":
  {
    listeEdelmetallProduktKonditionen:
      [{
        "kennziffer": "2201",
        "bezeichnung": "1. Au Lunar 31,1g Gold Ratte",
        "emBpBuyEditierbarKz": "J",
        "emWlBuyEditierbarKz": "N",
        "emMaBuyEditierbarKz": "J",
        "emBpBuyPreis": 125,
        "emWlBuyPreis": 130,
        "emMaBuyPreis": 120,
        "emMaBuyKondition": 1.9,
        "emBpBuyKondition": 2,
        "emWlBuyKondition": 5,
        "emWlBuyChanged": true
      },
      {
        "kennziffer": "2202",
        "bezeichnung": "Au Lunar 31,1g Gold Ratte",
        "emBpBuyEditierbarKz": "J",
        "emWlBuyEditierbarKz": "N",
        "emMaBuyEditierbarKz": "J",
        "emBpBuyPreis": 125,
        "emBpSellPreis": 110,
        "emMaBuyPreis": 120,
        "emMaBuyKondition": 1.9,
        "emWlBuyPreis": 130,
        "emBpBuyKondition": 2,
        "emBpSellKondition": 3,
        "emWlBuyKondition": 5,
        "changed": true
      },
      {
        "kennziffer": "2203",
        "bezeichnung": "Au Lunar 31,1g Gold",
        "emBpBuyEditierbarKz": "N",
        "emWlBuyEditierbarKz": "J",
        "emMaBuyEditierbarKz": "J",
        "emBpBuyPreis": 220,
        "emBpSellPreis": 196,
        "emWlBuyPreis": 250,
        "emMaBuyPreis": 210,
        "emMaBuyKondition": 0.9,
        "emBpBuyKondition": 1,
        "emBpSellKondition": 2,
        "emWlBuyKondition": 1
      }],
    listeStufenKonditionen: [
      {
        "emBpBuyEditierbarKz": "J",
        "emWlBuyEditierbarKz": "N",
        "emMaBuyEditierbarKz": "J",
        "emBpBuyPreis": 500,
        "emBpSellPreis": 500,
        "emWlBuyPreis": 500,
        "emMaBuyPreis": 500,
        "emMaBuyKondition": 1.9,
        "emBpBuyKondition": 2,
        "emBpSellKondition": 3,
        "emWlBuyKondition": 5
      }
    ]
  }
};

export default {
  konditionenKey,
  konditionenListe,
  stufenKonditionen,
  defaultKeys,
  defaultBetrag,
  listKeys,
  testData
};
